// extracted by mini-css-extract-plugin
module.exports = {"root":"Categories_root__vah7e","fullSize":"Categories_fullSize__nVrgK"};